import { http } from '@4beefopag/4bee-fopag-core/dist/services';
import { useState, useEffect } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useGetUtilizacaoFolhasPorCompetencia = (startDate, endDate) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const ini = startDate.startOf('month').format('YYYY-MM-DD');
        const fim = endDate.endOf('month').format('YYYY-MM-DD');

        const response = await http.get(`/requisicoes/folha/agrupado?ini=${ini}&fim=${fim}`);
        setData(response.data);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };
    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate]);

  return { loading, error, data };
};
